module.exports = __webpack_public_path__ + "img/failed.f612758c.png";